import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { t } from '../../../components/common/Translate';
import { Record } from '../../../config/Record/RecordEntity';
import { REACT_APP_API, RECORD_STATUS } from '../../../config';
import { country } from '../../../language-context';
import { currencySign } from '../../../Utils/currencySign';

const { repurchase_account, report } = RECORD_STATUS;

export const useFinal = (recordId) => {
  const history = useHistory();

  const record = useSelector((state) => state.reduxRecords.data[recordId]) || {};
  const finalPrice = useSelector((state) => state.reduxRecords.data[recordId])?.expertise?.finalPrice;
  const reportType = useSelector((state) => state.reduxRecords.data[recordId])?.reportExpertise?.reportId;
  const reportComment = useSelector((state) => state.reduxRecords.data[recordId])?.reportExpertise?.reportComment;
  const recordKey = useSelector((state) => state.reduxRecords.data[recordId])?.record?.recordKey;
  const languageId = useSelector((state) => state.reduxRecords.data[recordId])?.record?.countryId;
  const recoveryOffer = useSelector((state) => state.reduxRecords.data[recordId])?.valuation?.recoveryOffer || null;
  const downloadDocument = `${REACT_APP_API}/buyer/public/${recordKey}/${country[languageId]}/admin-documents/report-offer-reprise.pdf`;
  const countryPosId = useSelector((state) => state.reduxRecords.data[recordId]?.carcheckPointOfSale?.countryId);
  const recordEntity = new Record(record);
  const isVisible = recordEntity.finalizationIsVisible();
  const isNrmFinalizationActive = recordEntity.isNrmFinalizationActive();
  const isCounterAppraisalFinalizationActive = recordEntity.isCounterAppraisalFinalizationActive();

  const checkClickOrigin = (event) => {
    if (event.target.id !== 'theHref') {
      history.push({
        pathname: `/files/${recordId}/finalising`,
        state: {
          ...history.location.state,
        },
      });
    }
  };

  const goToFinalization = (e) => {
    if (!isVisible) return;
    checkClickOrigin(e);
  };

  // to check meaning and put somewhere else
  const labels = [];
  const status = recordEntity.status();
  if (status === repurchase_account && finalPrice)
    labels.push({
      label: t('buying_price'),
      value: currencySign(Math.round(finalPrice), null, countryPosId),
    });
  if (status === report && finalPrice)
    labels.push({
      label: t('reportType'),
      value: t(`reportType${reportType}`),
    });
  if (status === report && finalPrice)
    labels.push({
      label: t('comment'),
      value: reportComment,
    });

  return {
    isVisible,
    isNrmFinalizationActive,
    isCounterAppraisalFinalizationActive,
    goToFinalization,
    labels,
    downloadDocument,
    hasOffer: !!recoveryOffer,
  };
};
